import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { BackgroundQueueItem, BackgroundQueueItemCreate, BackgroundQueueItemFilter } from '../data/backgroundQueueItem';

export function createBackgroundQueueItemService(client: AxiosInstance) {
  return createCrudService<BackgroundQueueItem, BackgroundQueueItemCreate, BackgroundQueueItemFilter>(
    client,
    '/platform/BackgroundQueueItem',
    'id',
  );
}

export type BackgroundQueueItemService = CrudService<BackgroundQueueItem, BackgroundQueueItemCreate, BackgroundQueueItemFilter>;
